<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title">
                {{ $t('signup') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 내용 -->
        <!-- 비밀번호 입력 -->
        <div class="txt-password">{{ $t('password') }}</div>
        <div class="input-pwd-position">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd"> 
            <input class="input-pwd-00" type="password" v-model="mPass00" :placeholder=" $t('password_hint') ">
        </div>
       <!-- 비밀번호 재입력 -->
        <div class="txt-retry-password">{{ $t('re_password') }}</div>
        <div class="input-retry-pwd-position">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd"> 
            <input class="input-pwd-01" type="password" v-model="mPass01" :placeholder=" $t('password_hint') ">            
        </div>
        <div class="notice-text-00">{{ $t('attention') }}</div>

        <div class="notice-text-01" >{{ $t('signup_notice') }}</div>
        <div class="txt-recomm-code" v-show="mShowReffel">{{ $t('recomm_code') }}<font size=1 color="#5e5c5c">{{ $t('recomm_notice') }}</font></div>
        <!-- 라인 -->
        <div class="bottom-line" v-show="mShowReffel"></div>
        <!-- 라인 -->
        <div class="bottom-blue-line" v-show="mShowReffel"></div>
        <!-- 라인 -->
        <div class="bottom-blue02-line" v-show="mShowReffel"></div>        
        <!-- 추천친구 -->
        <div class="input-recomm-positon" v-show="mShowReffel">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-reffal"> 
            <input class="input-recom-code" type="text" v-model="mRecomCode" :placeholder=" $t('input_recomm') ">

            <!-- 리스트 팝업 -->
            <div class="referral-postion">
                <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                    color="#345993"
                    dark
                    v-on="on"
                    >
                    <div class=txt-referral>목록</div>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                    v-for="(item, index) in mReferral"
                    :key="index"
                    @click="onClickList(item.code)"
                    >
                    <v-list-item-title>{{ item.code }}</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>
            </div>

        </div>
        <!-- 다음버튼 -->
        <div class="btn-next-bg"
        @click.passive="onClickNext"
        v-ripple="{ center: true, class: `teal--text`  }">
            <div class="txt-next">{{ $t('next') }}</div>
        </div>      
    </v-app>
</template>
<script>
import axios from 'axios';
export default {
  created() {
    let payload = this.$route.query.payload;
    let decrypto = this.$cryptoUtil.decrptoMessage(payload);
    let json = JSON.parse(JSON.parse(decrypto));
    this.mEmail = json.account;
    this.mSnsKey = json.sns_key;   
    this.mReferral = json.referral;
    console.log("email :: " + this.mEmail )
    console.log("mSnsKey :: " + this.mSnsKey )
    console.log("mReferral :: " + this.mReferral)
  },
  data: () => ({
      mPass00 : "",
      mPass01 : "",
      mRecomCode : "",
      mEmail : "",
      mSnsKey : "",
      mMarket : "AND",
      mLang : "KOR",
      mTokenID : "",
      mShowReffel : false,
      mReferral : "",
  }),
  methods : {
      onClickList : function(code) {
        this.mRecomCode = code;
      },
      onClickNext : function() {
            if(this.mPass00.length < 8) {
                alert(this.$t('input_pass_8digit'));
                return;
            }
            else if(this.mPass00.length >= 16) {
                alert(this.$t('input_pass_16down'));
                return;
            }
            else if(this.mPass00 != this.mPass01) {
                alert(this.$t('retry_pass'));
                return;
            }
            // 비밀번호 문자열에 숫자 존재 여부 검사
            var pattern1 = /[0-9]/;  // 숫자
            if(pattern1.test(this.mPass00) == false) {
                let message = this.$t('no_number_pass');
                alert(message);
                return;
            }
            // 비밀번호 문자열에 영문 소문자 존재 여부 검사
            var pattern2 = /[a-z]/;
            if(pattern2.test(this.mPass00) == false) {
                let message = this.$t('no_albert_pass');
                alert(message);
                return;
            }

            let sha256Pass = this.$cryptoUtil.sha256Crypto(this.mPass00);
            let payload = {};
            payload.cmd = "new-user";
            payload.account = this.mEmail;
            payload.sns_key = this.mSnsKey;
            payload.passwd = sha256Pass;
            payload.recommender_code = this.mRecomCode;
            payload.market = this.mMarket;
            payload.language = this.mLang;
            payload.token_id = this.mTokenID;
            
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    alert(this.$t('reg_compete'));
                    var json = {};
                    json.cmd = "sign-in";
                    json.account = this.mEmail;
                    json.sns_key = this.mSnsKey;
                    this.loginServer(JSON.stringify(json));
                } else if(serverResponse.result == "2") { // 기존사용자존재
                    alert(this.$t('exist_user_error'));
                } else if(serverResponse.result == "0") { // 오류
                    alert(serverResponse.message);
                }
            })
            .catch( ()=>{} );
        },
        onClickBack : function() {
            this.$router.go(-1);            
        },
        loginServer(reqDataJson) { // 로그인하기
            this.mShowLoading = false;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(reqDataJson), "K"))
            .then(response => {
                this.mShowLoading = true;   
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));       
                if(serverResponse.result == "1") { // 성공
                    console.log(response)
                    let payload = {};
                    payload.mno = serverResponse.mno;
                    payload.email = this.mEmail;
                    payload.notice = serverResponse.notice;
                    let payloadJson = JSON.stringify(payload);
                    let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
                    this.$router.push( { path : 'wallet_list', query: { payload: crypto }  } );
                } else if(serverResponse.result == "2") { // 신규가입유도
                   
                } else if(serverResponse.result == "0") { // 오류
                    alert(serverResponse.message);
                }
            })
            .catch( ()=>{} );
        },
  }
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "NanumBarunGothicOTF", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.img-logo {
    height: 36.85vw;
    width: 63.9vw;
}
.logo-img-position {
    position: absolute;
    top: 39.6vh;
    left: 18.1vw;
}
.copyright-position {
    position: absolute;
    bottom: 4.2vh;
    left: 15.88889vw;
}
.img-copyright {
    height: 3.3vw;
    width: 68.5vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;  
}
.btn-next-bg {
    position: fixed;
    bottom: 0px; 
    left: 0px;
    width: 100vw;
    height: 14.35vw; 
    background-color: #345993;
}
.txt-next {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto; 
    text-align: center;
    color: white;
    font-size: 4.148vw;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none; 
}
.txt-password {
    position: absolute;
    top: 17.35vw; 
    left: 5.9vw;
    color : #345993;
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;
}
.input-pwd-position {
    position: absolute;
    top: 21.8vw; 
    left: 5.6vw;
}
.img-input-pwd {
    height: 8.88vw;
    width: 88.9vw;
}
.txt-retry-password {
    position: absolute;
    top: 36.148vw; 
    left: 5.6vw;
    color : #345993;
    font-weight: bold;
    font-size: 3.22vw;
    font-family: NanumBarunGothicOTF;
}
.input-retry-pwd-position {
    position: absolute;
    top: 40.74vw; 
    left: 5.6vw;
}
.notice-text-00 {
    position: absolute;
    top: 53.37vw; 
    left: 6.1vw; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;      
}
.notice-text-01 {
    position: absolute;
    top: 57.4vw; 
    left: 6.1vw; 
    right: 6.1vw;
    width: auto;
    height: auto; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;     
}
.txt-recomm-code {
    position: absolute;
    top: 75.92vw; 
    left: 5.9vw;  
    color: #345993;   
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;     
}
.input-recomm-positon {
    position: absolute;
    top: 80.55vw; 
    left: 5.9vw;   
    height: 8.88vw;
    width: 88.9vw;       
}
.img-input-reffal {
    height: 8.88vw;
    width: 68vw;
}
.input-recom-code {
    position: absolute;
    top: 28%; 
    left: 0vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.bottom-line {
    position: absolute;
    top: 70.92593vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.bottom-blue-line {
    position: absolute;
    top: 70.92593vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.bottom-blue02-line {
    position: absolute;
    top: 72vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.input-pwd-00 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;
    padding-left: 5vw;
    font-size: 3.2vw;
}
.input-pwd-01 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.referral-postion {
    position: absolute;
    top: 0%; 
    right: 0%;  
}
.txt-referral {
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: white;
}
*:focus {
    outline: none;
}
</style>